import * as React from 'react';
import styled from 'styled-components';
import { Text, SeparatorWithContent, themeGet } from '@packages/ui';
import {
  NewsletterFooterInputSection,
  NewsletterFooterInputSectionProps,
  NewsletterFooterSubmitMessageProps,
} from '../../components/NewsletterFooter';

const Container = styled.div`
  background-color: ${themeGet.colors('desertStorm')};
  padding-bottom: ${themeGet.space(2)};
  & > :first-child {
    margin-bottom: ${themeGet.space(1)};
  }
`;

export interface NewsletterFooterProps extends NewsletterFooterInputSectionProps, NewsletterFooterSubmitMessageProps {
  heading: string;
  isSubmitted: boolean;
}

export const NewsletterFooter: React.FC<NewsletterFooterProps> = ({
  heading,
  mainText,
  dataProtectionNote,
  dataProtectionLinkUrl,
  dataProtectionLinkLabel,
  signUpButtonLabel,
  signUpButtonPlaceholder,
  isSubmitted,
  submitMessage,
  onSubmit: onClick,
  disableSubmitButton,
  errorMessage,
  invalidEmailErrorMessage,
  showContentfulHeading,
  hightlightsMsg,
  offersMsg,
  trendsMsg,
}) => {
  return (
    <Container className="newsletterContainer">
      <SeparatorWithContent>
        <Text tag="h2" fontFamily="brandSecondary" fontSize={8} mb={2} mt={2}>
          {heading}
        </Text>
      </SeparatorWithContent>
      <NewsletterFooterInputSection
        disableSubmitButton={disableSubmitButton}
        errorMessage={errorMessage}
        invalidEmailErrorMessage={invalidEmailErrorMessage}
        mainText={mainText}
        dataProtectionNote={dataProtectionNote}
        dataProtectionLinkLabel={dataProtectionLinkLabel}
        dataProtectionLinkUrl={dataProtectionLinkUrl}
        signUpButtonLabel={signUpButtonLabel}
        signUpButtonPlaceholder={signUpButtonPlaceholder}
        onSubmit={onClick}
        showContentfulHeading={showContentfulHeading}
        offersMsg={offersMsg}
        trendsMsg={trendsMsg}
        hightlightsMsg={hightlightsMsg}
        isSubmitted={isSubmitted}
        submitMessage={submitMessage}
      />
    </Container>
  );
};
